import { useEffect, useState } from "react";
import useTitle from "../../hooks/useTitle";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useOtpPasswordMutation } from "./otpApiSlice";
import { useNavigate } from "react-router-dom";




const SetPasswordPage = () => {
  useTitle("Vizta");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [otp, setOtp] = useState(Array(5).fill(""));
  const [newPassword, setNewPassword] = useState("");
  const [showError, setShowError] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [formData, setFormData] = useState({
    otp: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const navigate = useNavigate();


  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);

  };
  const handleToggleshowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }


  const [
    otpPassword,
    { data: updatedPasswordData, isLoading, isSuccess, isError, error },
  ] = useOtpPasswordMutation();

  const handlePaste = (e) => {
    e.preventDefault(); // Prevent default paste behavior
    const pastedData = e.clipboardData.getData("Text").slice(0, 5); // Get up to 5 digits
    const updatedOtp = [...otp];

    // Distribute pasted digits across inputs
    for (let i = 0; i < pastedData.length; i++) {
      updatedOtp[i] = pastedData[i];
    }

    setOtp(updatedOtp); // Update OTP state
  };

  const handleOtpChange = (index, value) => {
    if (/^\d?$/.test(value)) { // Ensure only numeric values
      const updatedOtp = [...otp];
      updatedOtp[index] = value;

      setOtp(updatedOtp);

      // Automatically focus the next input if the current one is filled
      if (value && index < 4) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (isError) {
      setShowError(true);
      setErrorMsg(error?.data?.message || "An error occurred");
    }
  }, [isError, error]);



  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.newPassword || !formData.confirmNewPassword || otp.some((o) => o === "")) {
      // console.log("Please fill all fields correctly");
      setShowError(true)
      setErrorMsg("Please fill all fields correctly")
      return;
    }

    if (formData.newPassword !== formData.confirmNewPassword) {
      // console.log("New password and confirm password do not match");
      setShowError(true)
      setErrorMsg("New password and confirm password do not match")
      return;
    }

    otpPassword({
      newpassword: formData.confirmNewPassword,
      otp: otp.join(""),
    });
  };

  useEffect(() => {
    setShowError(false)
  }, [formData])


  if (isSuccess) {
    setTimeout(() => {
      navigate(`/login/?user=${updatedPasswordData?.user}`);
    }, 900);

    return (
      <div className="App flex items-center justify-center">
        <div className="box">
          <img src="/images/verified.gif" alt="Verified" />
          {updatedPasswordData.msg}
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-4 bg-gray-100">
      <main className="w-full max-w-4xl flex flex-col lg:flex-row bg-white shadow-md rounded-lg overflow-hidden">
        {/* left-side */}
        <section className="flex flex-col justify-evenly items-center lg:w-1/2 p-4">
          {showError ? <p className="text-red-600 text-xl font-medium w-[95%] text-center bg-red-200 border border-red-600 rounded-lg flex items-center justify-center py-[0.8rem]">
            {errorMsg}
          </p> : (<img src="/assets/viz.png" alt="Logo" className="w-1/2 mb-4" />)}

          {/* <img src="/assets/viz.png" alt="Logo" className="w-1/2 mb-4" /> */}
          <form
            className="w-full flex flex-col gap-4 items-center"
            onSubmit={handleSubmit}
          >
            <div className="text-2xl font-medium text-blue-950 w-full text-center mb-2">
              <h1>Set New Password</h1>
              <p className="text-lg font-normal">
                Enter the OTP and your new password
              </p>
            </div>
            <div className="container flex items-center justify-evenly w-full">
              {Array.from({ length: 5 }).map((_, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`} // Unique ID for each input to control focus
                  className="border border-black w-[2.2rem] h-[2.2rem] text-center"
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  value={otp[index] || ""}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onPaste={(e) => handlePaste(e)}
                />
              ))}
            </div>

            <div className="flex flex-col justify-center gap-4 w-full">
              <label htmlFor="new-password" className="text-xl font-medium">
                New Password:
              </label>
              <div className="relative">
                <input
                  name="newPassword"
                  className="text-2xl rounded-md border-2 px-4 py-2 w-full"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  value={formData.newPassword}
                  onChange={handleInputChange}

                />
                <span className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  onClick={handleTogglePasswordVisibility}
                >
                  {showPassword ? (
                    <FaEyeSlash fill="#4e4e52" />
                  ) : (
                    <FaEye fill="#4e4e52" />
                  )}
                </span>

              </div>
              <label
                htmlFor="confirm-password"
                className="text-xl font-medium"
              >
                Confirm Password
              </label>
              <div className="relative">
                <input
                  name="confirmNewPassword"
                  className="text-2xl rounded-md border-2 px-4 py-2 w-full"
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm password"
                  value={formData.confirmNewPassword}
                  onChange={handleInputChange}

                />

                <span className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={handleToggleshowConfirmPassword}>
                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div className="flex justify-between items-center">
                <button
                  className="w-40 text-xl font-normal h-14 rounded border bg-gray-200"
                  type="button"
                  onClick={() => navigate("/login")}
                >
                  Cancel
                </button>
                <button
                  className="w-40 text-xl font-normal h-14 rounded border bg-blue-950 text-white"
                  type="submit"
                // disabled={
                //   isLoading ||
                //   formData.newPassword.length !==
                //   formData.confirmNewPassword.length ||
                //   otp.some((o) => o === "")
                // }
                >
                  {isLoading ? "Updating..." : "Set Password"}
                </button>
              </div>
              {/* {formData.newPassword !== formData.confirmNewPassword ? (
                <p className="text-left w-full text-red-500">
                  new password and confirm new password is not same
                </p>
              ) : null}
              {isError && formData.newPassword === formData.confirmNewPassword ? (
                <p className="text-left w-full text-red-500">
                  {error.data?.message}
                </p>
              ) : null}
              {otp.some((o) => o === "") && (
                <p className="text-left w-full text-red-500">
                  OTP is not filled
                </p>
              )} */}

              {/* {showError ? <p className="text-left w-full text-red-500">
                {errorMsg}
              </p> : null} */}

            </div>
          </form>
        </section>
        <div className="bg-gray-300 border relative top-0 lg:left-[0.7rem] md:h-[2px] w-[90%] md:w-[2px] lg:h-[75vh]"></div>
        {/* right-side */}
        <section className="lg:w-1/2 flex flex-col items-center justify-center bg-gray-200 p-4">
          <h2 className="text-2xl lg:text-3xl text-center mb-4">
            Data Visualized, Decisions Amplified
          </h2>
          <img
            src="/assets/Data-report.png"
            alt="dataReport"
            className="w-3/4 mb-4"
          />
          <p className="text-lg font-medium text-center px-4">
            Decisions thrive when rooted in data. Harness the power of insights
            to drive informed choices and unlock unparalleled success.
          </p>
          <div className="mt-4">
            <img src="/assets/logo.png" alt="Logo" className="w-32" />
          </div>
        </section>
      </main>
    </div>
  );
};

export default SetPasswordPage;
